import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { FaEnvelope, FaEye, FaEyeSlash, FaPhone } from 'react-icons/fa6'
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'


const PasswordInput = ({ placeholder, handleChange, value }) => {
    const [show, setShow] = useState(false)

    return (
        <Form className='col'>
            <Form.Group className=" mb-3 bg-light rounded-3 align-items-center row g-0">
                <div className="col">
                    <Form.Control
                        className="bg-transparent border-0"
                        placeholder={placeholder}
                        onChange={handleChange}
                        value={value}
                        type={show ? "text" : "password"}
                    />
                </div>

                <div className="col-auto px-4">
                    <span onClick={() => { setShow(!show) }} className="text-muted">{show ? < FaEyeSlash /> : < FaEye />}</span>
                </div>
            </Form.Group>
        </Form>
    )
}

const AppInput = ({ type, icon, placeholder, handleChange, value }) => {

    return (
        <Form className='col'>
            <Form.Group className=" mb-3 bg-light rounded-3 align-items-center row g-0">
                <div className="col">
                    <Form.Control
                        className="bg-transparent border-0"
                        placeholder={placeholder}
                        onChange={handleChange}
                        value={value}
                        type={type}
                    />
                </div>
                {icon && (
                    <div className="col-auto px-4">
                        <span className="text-muted">{icon === "phone" ? < FaPhone /> : < FaEnvelope />}</span>
                    </div>
                )}
            </Form.Group>
        </Form>
    )
}

const AppPhoneInput = ({ handleChange, value }) => {
    return (
        <PhoneInput
            value={value}
            className="phone-input border-0 rounded mb-3"
            onChange={handleChange}
            defaultCountry="US"
        />
    )
}



export { PasswordInput, AppInput, AppPhoneInput }